import { render, staticRenderFns } from "./NewItems.vue?vue&type=template&id=3ccdaf46&scoped=true"
import script from "./NewItems.vue?vue&type=script&lang=js"
export * from "./NewItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccdaf46",
  null
  
)

export default component.exports